import React, { Children, useEffect, useState, useRef } from 'react'

import classes from "../HolidayMode/HolidayModeCardContentLayout.module.css";
import arrowIcon from "../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Page - Forward.svg";
import Pill_Widget from '../../../Widgets/Pill_Widget';
import Modal from '../../../../Modal/Modal';
import List from './List';
import AffectedSwitchesList from './AffectedSwitchesList';
import Button1 from '../../../Button/Button1';
import { addActionToAdvRule, deleteAdvRule, getSiteByUUID, removeActionFromAdvRule, setAdvRuleEnabled, setInputRuleApi } from '../../../../../Api Methods/Api';
import { useDispatch, useSelector } from 'react-redux';
import Button2 from '../../../Button/Button2';
import areYouSureAnim from '../../../../../assets/animations/areYouSure.json'
import successAnim from '../../../../../assets/animations/success.json'
import failAnim from '../../../../../assets/animations/fail.json'
import { act } from 'react';
import { Description } from '@headlessui/react';
import { format } from 'date-fns';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';
import ChoosePin from '../CreateRuleNew/ChoosePin';
import { Divider } from 'primereact/divider';
import ChooseWhatAdvRule from '../CreateRuleNew/ChooseWhatAdvRule';
import AddAdvRuleAction from '../CreateRuleNew/AddAdvRuleAction';
import ChooseWhatAddAdvRuleAction from '../CreateRuleNew/ChooseWhatAddAdvRuleAction';
import { RuleProvider, useRule } from '../CreateRuleNew/RuleReducer';
import { Link } from 'react-router-dom';
import RuleCard from '../../Rules/RuleCard';


const AdvRuleLayout = ({ item, fetchAutomations, pins, smartLocks }) => {
    console.log(item);

    const { rule, conditions, actions } = item;
    const { state, dispatch } = useRule(RuleProvider);
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const role = useSelector(state => state.auth.role);
    const [allSites, setAllSites] = useState({});
    const [_actions, setActions] = useState(actions);
    const [_rule, setRule] = useState(rule);
    const [masterSite, setMasterSite] = useState("")


    const ruleName = _rule.name || "No name provided"
    const ruleOwner = rule.site_owner
    const ruleDescription = _rule.description || "No description provided"
    const ruleEnabled = _rule.is_enabled == 1
    const created = _rule.created_at
    const createdBy = _rule.created_by_name || "Unknown user"
    const lastUpdated = _rule.updated_at
    const ruleID = _rule.rule_id

    const [showEditRule, setShowEditRule] = useState(false)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showFail, setShowFail] = useState(false)
    const [showEdit, setShowEdit] = useState(false)
    const [showAddAction, setShowAddAction] = useState(false)
    const [showChooseWhat, setShowChooseWhat] = useState(false)

    let usedKeys = []
    let usedAffectedKeys = []

    const [newSelectedPin, setNewSelectedPin] = useState({})

    const [linkedSites, setLinkedSites] = useState([])

    const apiData = {
        token,
        client
    }

    const ModalDialog = useRef();
    const ClearStatesChildComponetRef = useRef();

    useEffect(() => {
        if (!rule) return;
        getSiteInfo(_rule.site_owner);
        // _actions.map(action => {
        //     setLinkedSites(getSiteInfo(action.site_to))
        // })
        


        const uniqueActionSites = [
            ...new Set(_actions.map(a => a.site_to).filter(id => id !== _rule.site_owner))
        ];

        uniqueActionSites.forEach(uuid => getSiteInfo(uuid));
    }, [_rule, _actions]);

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        }
        HandelResetModal();
    }

    const [modalTitle, setModalTitle] = useState("")
    const [modalComponent, setModalComponent] = useState()
    const [modalPageIndex, setModalPageIndex] = useState(null);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
                setModalPageIndex(null);
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const HandelResetModal = () => {
        setModalPageIndex(null);
    }

    // re-render modal to show new modal componet. 
    useEffect(() => {
        console.log(modalPageIndex);
        switch (modalPageIndex) {
            case 1:
                //setModalComponent(<ScheduledAction body={body} OutPutOptions={OutPutOptions} title={title} isReminder={isReminder} nextPage={setModalPageIndex} onSubmit={UpdateSchedule} DeleteSchedule={DeleteSchedule} showRemoveScheduleButton={showRemoveScheduleButton} />)
                HandleShowModal();
                break;
            case 3:
                //setModalComponent(<SelectOutputs body={body} setBody={setBody} listItems={OutPutOptions} modalPageIndex={modalPageIndex} nextPage={setModalPageIndex} showAutomation={isReminder} time={time} />)
                break;
        }

    }, [modalPageIndex, item])


    const apiDispatch = useDispatch();


    const deleteRule = async () => {
        const response = await deleteAdvRule(apiData, ruleID, apiDispatch)
        if (response.success) {
            setShowEditRule(false)
            setShowConfirmation(false)
            setShowSuccess(true)
            HandleCloseModal()
            fetchAutomations()
        } else {
            setShowConfirmation(false)
            setShowFail(true)
        }
    }

    const convertUTCTimeToLocal = (utcTimeStr) => {
        if (!utcTimeStr) return null;
        const [hours, minutes] = utcTimeStr.split(':');
        const d = new Date();
        d.setUTCHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
        return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    };

    const convertDaysOfTheWeek = (daysSelected) => {
        // Server uses JS convention: 0=Sun, 1=Mon, 2=Tues, 3=Wed, 4=Thur, 5=Fri, 6=Sat
        const dayMap = { "0": "Sun", "1": "Mon", "2": "Tues", "3": "Wed", "4": "Thur", "5": "Fri", "6": "Sat" };
        const selectedDayNames = daysSelected
            .slice()
            .sort((a, b) => a - b)
            .map(d => dayMap[d])
            .join(',');

        if (selectedDayNames === "Mon,Tues,Wed,Thur,Fri") {
            return "on weekdays";
        } else if (selectedDayNames === "Sun,Sat") {
            return "on weekends";
        } else if (selectedDayNames === "Sun,Mon,Tues,Wed,Thur,Fri,Sat") {
            return "everyday";
        } else {
            return "on " + selectedDayNames.split(',').join(', ');
        }
    }

    const getSiteInfo = async (uuid) => {
        if (!uuid) return;

        const response = await getSiteByUUID(apiData, uuid, apiDispatch);
        if (response.success) {
            const deviceDetailsParsed = JSON.parse(response.data.deviceDetails);

            setAllSites(prev => ({
                ...prev,
                [uuid]: {
                    ...response.data,
                    deviceDetailsParsed
                }
            }));
        }
    };

    const convertConditionPinState = (deviceDetails, pinNumber, pinState, isAbsence = false) => {
        if (!deviceDetails || !deviceDetails[pinNumber]) return "Loading...";

        const pin = deviceDetails[pinNumber];
        const isLock = smartLocks.some(lock => lock.outputPin == pinNumber);

        if (isAbsence) {
            console.log(pinState);
            switch (pinState) {
                case "ARMED":
                    return isLock ? "has NOT been closed" : `has NOT been ${pin.pinStatusOn}`;
                case "DISARMED":
                    return isLock ? "has NOT been opened" : `has NOT been ${pin.pinStatusOff}`;                
                    default:
                    return `has NOT been ${pinState}`;
            }
        }
console.log(pinState);
        switch (pinState) {
            case "ARMED":
                return isLock ? "is closed" : `is ${pin.pinStatusOn}`;
            case "DISARMED":
                return isLock ? "is open" : `is ${pin.pinStatusOff}`;
            case "TEMP_ARM":
                return `is temporarily ${pin.pinStatusOn}`
            case "TEMP_DISARM":
                return `is temporarily ${pin.pinStatusOff}`
            case "PULSE":
                return `pulses`
            case "ANY":
                return isLock ? "is opened or closed" : `is ${pin.pinStatusOn} or ${pin.pinStatusOff}`;
            default:
                return "Unknown";
        }
    };

    const formatAlertRecipient = (action) => {
        switch (action.alert_recipient_type) {
            case "JUST_ME": return "rule creator";
            case "ALL_MANAGERS": return "all managers";
            case "ALL_STANDARD_USERS": return "all standard users";
            case "SELECTED_USERS": return `${action.target_users?.length ?? 0} specific user(s)`;
            default: return action.alert_recipient_type ?? "unknown";
        }
    };

    const formatAlertType = (action) => {
        switch (action.alert_level){
            case "STANDARD": return "standard";
            case "CRITICAL": return "CRITIAL";
            default: return ""
        }
    }

    const SNAPSHOT_PROVIDER_LABELS = { AJAX: "Ajax", DAHUA: "Dahua", HIKVISION: "Hikvision" };

    const formatSnapshotAction = (action) => {
        const targets = action.snapshot_targets ?? [];
        if (targets.length === 0) return "Take snapshot";
        const targetText = targets
            .map(t => {
                const providerLabel = SNAPSHOT_PROVIDER_LABELS[t.provider] ?? t.provider;
                return t.channel != null ? `${providerLabel} - Channel ${t.channel}` : providerLabel;
            })
            .join(", ");
        return `Take snapshot (${targetText})`;
    }


    const convertActionPinState = (deviceDetails, pinNumber, pinState) => {
        if (!deviceDetails || !deviceDetails[pinNumber]) return "Loading...";

        switch (pinState){
            case "MATCH" :
                return `match its state`
            case "ARM":
                return `${deviceDetails[pinNumber].actionOneOffLabel || "arm"}`
            case "DISARM": 
                return `${deviceDetails[pinNumber].actionOneOnLabel || "disarm"}`
            case "PULSE":
                return `pulse`
            case "TEMP_ARM":
                return `temporarily ${deviceDetails[pinNumber].actionOneOffLabel || "arm"}`
            case "TEMP_DISARM":
                return `temporarily ${deviceDetails[pinNumber].actionOneOnLabel || "disarm"}`
            case "TOGGLE":
                return "toggle"
            default: 
                return "Unknown"
        }
    }

    const setRuleEnabled = async () => {
        const body = {
            enabled: _rule.is_enabled == 1 ? false : true
        }

        const response = await setAdvRuleEnabled(apiData, body, _rule.rule_id, apiDispatch)
        if (response.success){
            const updatedRule = {
                ..._rule,
                is_enabled: _rule.is_enabled == 1 ? 0 : 1
            };
            setRule(updatedRule)
        }
    }

    const deleteAction = async (actionID) => {
        const response = await removeActionFromAdvRule(apiData, actionID, apiDispatch)
        if (response.success){
            setActions(prev =>
                    prev.filter(a => a.action_id !== actionID)
            );
        }
    }

    const navigate = () => {
        setShowAddAction(false)
        setShowChooseWhat(true)
    }

    const saveNewAction = async () => {
        setShowChooseWhat(false)
        const response = await addActionToAdvRule(apiData, _rule.rule_id, state.actionToAdd, apiDispatch)
        console.log(_rule.rule_id);
        console.log(state.actionToAdd);
        console.log(response);
        if (response.success){
             const updatedActions = [..._actions, state.actionToAdd];
             setActions(updatedActions)
        }
    }

    // const navigateToSite = (uuid) => {
    //     dispatch(serviceActions.setDeviceUUID(uuid));
    //     useSetCookie("DeviceUUID", uuid, 1);
    //     navigate("/portal/SiteView/" + uuid);
    // }

    const triggerItems = conditions.map(condition => {
        const site = allSites[_rule.site_owner];
        if (!site) return null;
        const deviceDetails = site?.deviceDetailsParsed;
        const pinName = deviceDetails?.[condition.pin]?.pinName || 'Loading...';
        const stateText = convertConditionPinState(deviceDetails, condition.pin, condition.pin_state || "PULSE", condition.is_absence_condition);
        const timeText = condition.time_window_start && condition.time_window_end
            ? ` between ${convertUTCTimeToLocal(condition.time_window_start)} and ${convertUTCTimeToLocal(condition.time_window_end)}`
            : '';
        const daysText = convertDaysOfTheWeek(condition.days_of_week ? JSON.parse(condition.days_of_week) : ["0", "1", "2", "3", "4", "5", "6"]);
        const siteLabel = site.uuid != DeviceUUID ? `${site.tag || site.key} - ` : '';
        const text = `${siteLabel}When ${pinName} ${stateText}${timeText} ${daysText}`.trim();
        if (site.uuid != DeviceUUID) {
            return (
                <a href={`/Dashboard/SiteView/${site.uuid}`} target="_blank" rel="noopener noreferrer">
                    {text}
                </a>
            );
        }
        return text;
    }).filter(Boolean);

    const actionItems = _actions.map(action => {
        console.log(action);
        if (action.action_type === "SEND_ALERT") return `Will send ${formatAlertType(action)} alert to ${formatAlertRecipient(action)}`;
        if (action.action_type === "SEND_ARC") return "Will notify monitoring arc"
        if (action.action_type === "CREATE_SNAPSHOT") return formatSnapshotAction(action);
        const site = allSites[action.site_to];
        if (!site) return null;
        const tag = site.tag || "";
        const deviceDetails = site?.deviceDetailsParsed;
        const pinName = deviceDetails?.[action.target_output]?.pinName || 'Loading...';
        const actionText = convertActionPinState(deviceDetails, action.target_output, action.control_type);
        const timeText = action.temporary_time_ms && (action.control_type === "TEMP_ARM" || action.control_type === "TEMP_DISARM")
            ? ` for ${action.temporary_time_ms / 60000 < 1 ? `${action.temporary_time_ms / 1000} seconds` : `${action.temporary_time_ms / 60000} minutes`}`
            : '';
        const delayText = action.delay_seconds > 0 ? ` after ${action.delay_seconds} seconds` : '';
        const text = `${tag} (${site.key}) - ${pinName} will ${actionText}${timeText}${delayText}`.trim();
        if (site.uuid != DeviceUUID) {
            return (
                <a href={`/Dashboard/SiteView/${site.uuid}`} target="_blank" rel="noopener noreferrer">
                    {text}
                </a>
            );
        }
        return text;
    }).filter(Boolean);

    return (
        <>
            <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "700px", minHeight: "420.5px" }} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

            {allSites[_rule.site_owner] && (
                <Dialog
                    header="View rule"
                    visible={showEdit}
                    style={{ width: "40vw", maxHeight: "70vh", overflowY: "auto" }}
                    onHide={() => setShowEdit(false)}
                >

                    <p>
                        {`Rule owner: ${allSites[_rule.site_owner].tag || ""} (${allSites[_rule.site_owner].key})`}
                    </p>
                    <p>
                        {`Name: ${_rule.name}`}
                    </p>
                    <p>
                        {`Description: ${_rule.description ?? "Not provided"}`}
                    </p>
                    <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                        {_rule.is_enabled == 1 ? "Rule status: enabled" : "Rule status: disabled"}
                        <Button icon="pi pi-arrow-right-arrow-left" rounded text aria-label="Filter" onClick={() => setRuleEnabled()}/>
                    </p>
                    <p>{`Created: ${format(new Date(_rule.created_at), "MMM do, yyyy - HH:mm")}`}</p>
                    <Divider type='solid' />
                   <h3 style={{color:"#6e6e6eff", fontWeight:600}}>Trigger:</h3>
                    {conditions.map(condition => {
                        const site = allSites[_rule.site_owner]; // master site
                     
                        if (!site) return null;
                        const deviceDetails = site?.deviceDetailsParsed;
                        return (
                            <div key={condition.condition_id}>
                                <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                {`When ${deviceDetails?.[condition.pin]?.pinName || 'Loading...'}
                                ${convertConditionPinState(deviceDetails, condition.pin, condition.pin_state || "PULSE", condition.is_absence_condition)}
                                ${condition.time_window_start && condition.time_window_end
                                    ? `between ${convertUTCTimeToLocal(condition.time_window_start)} and ${convertUTCTimeToLocal(condition.time_window_end)}`
                                    : ''
                                }
                                ${convertDaysOfTheWeek(condition.days_of_week ? JSON.parse(condition.days_of_week) : ["0", "1", "2", "3", "4", "5", "6"])}`}

                                {/* <Button icon="pi pi-pen-to-square" rounded text aria-label="Filter" /> */}
                                </p>
                            </div>
                        );
                    })}
                    <Divider type='solid' />
                    <h3 style={{color:"#6e6e6eff", fontWeight:600}}>Actions:</h3>
                    {_actions.map(action => {

                        if (action.action_type === "SEND_ALERT") {
                            return (
                                <div key={action.action_id}>
                                    <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                        {`Will send ${formatAlertType(action)} alert to ${formatAlertRecipient(action)}`}
                                        <Button icon="pi pi-trash" rounded text aria-label="Delete" onClick={() => deleteAction(action.action_id)} />
                                    </p>
                                    <Divider type='dashed' />
                                </div>
                            );
                        }

                        if (action.action_type === "SEND_ARC") {
                            return (
                                <div key={action.action_id}>
                                    <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                        {`Will notify monitoring arc`}
                                        <Button icon="pi pi-trash" rounded text aria-label="Delete" onClick={() => deleteAction(action.action_id)} />
                                    </p>
                                    <Divider type='dashed' />
                                </div>
                            );
                        }

                        if (action.action_type === "CREATE_SNAPSHOT") {
                            return (
                                <div key={action.action_id}>
                                    <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                        {formatSnapshotAction(action)}
                                        <Button icon="pi pi-trash" rounded text aria-label="Delete" onClick={() => deleteAction(action.action_id)} />
                                    </p>
                                    <Divider type='dashed' />
                                </div>
                            );
                        }

                        const site = allSites[action.site_to];
                        if (!site) return null;
                        const tag = site.tag || "";
                        const deviceDetails = site?.deviceDetailsParsed;
                        return (
                            <div key={action.action_id}>
                                <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                    {`${tag} (${site.key}) -
                                    ${deviceDetails?.[action.target_output]?.pinName || 'Loading...'}
                                    will ${convertActionPinState(deviceDetails, action.target_output, action.control_type)}
                                    ${(action.temporary_time_ms && (action.control_type == "TEMP_ARM" || action.control_type == "TEMP_DISARM"))? (action.temporary_time_ms / 60000 < 1 ? `For ${action.temporary_time_ms / 1000} seconds` : `For ${action.temporary_time_ms / 60000} minutes`) : ''}
                                    ${action.delay_seconds > 0 ? `After ${action.delay_seconds} seconds` : ''}`}
                                    <Button icon="pi pi-trash" rounded text aria-label="Delete" onClick={() => deleteAction(action.action_id)} />
                                </p>
                                <Divider type='dashed' />
                            </div>
                        );
                    })}
                    
                    <Button label="Add an action" severity="info" rounded icon="pi pi-plus" onClick={() => {setShowAddAction(true)}} />

                </Dialog>)}

            <Dialog
                header="Add rule action"
                visible={showAddAction}
                style={{ width: "40vw" }}
                onHide={() => setShowAddAction(false)}
            >
                <AddAdvRuleAction rule={_rule} actions={_actions} conditions={conditions} pins={pins} smartLocks={smartLocks} closeDialog={() => navigate()} setNewSelectedPin={setNewSelectedPin}/>
            </Dialog>

            <Dialog 
                header="Add action"
                visible={showChooseWhat}
                style={{ width: "40vw" }}
                onHide={() => setShowChooseWhat(false)}
            >
                <ChooseWhatAddAdvRuleAction selectedPinToAffect={newSelectedPin[0]} closeDialog={() => saveNewAction()} />
            </Dialog>

            <Dialog
                header="Success"
                visible={showSuccess}
                style={{ width: "40vw" }}
                onHide={() => setShowSuccess(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{ color: "#6e6e6eff" }}>Action completed successfully</h3>
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />

                    <Button label="Close & refresh" icon="pi pi-times" severity="primary" onClick={() => { setShowSuccess(false); fetchAutomations(); }} />
                </div>
            </Dialog>

            <Dialog
                header="Error"
                visible={showFail}
                style={{ width: "40vw" }}
                onHide={() => setShowFail(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>Something went wrong!</h3>
                    <p style={{ textAlign: "center" }}>Failed to complete requested action, please try again.</p>
                    <br></br>

                    <Button icon="pi pi-times"  label="Okay" severity="secondary" onClick={() => setShowFail(false)} />
                </div>
            </Dialog>

            <Dialog
                header="Are you sure?"
                visible={showConfirmation}
                style={{ width: "40vw" }}
                onHide={() => setShowConfirmation(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                    <Lottie
                        animationData={areYouSureAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to delete this rule?`}</h3>
                    <br />
                    <Button label="No, cancel"  icon="pi pi-times" severity="secondary" onClick={() => setShowConfirmation(false)} />
                    <br />
                    <Button label="Yes, delete rule" icon="pi pi-check" severity="danger" onClick={() => deleteRule()} />

                </div>
            </Dialog>

            <Dialog
                header="Edit Rule"
                visible={showEditRule}
                style={{ width: "40vw" }}
                onHide={() => setShowEditRule(false)}
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px', // Spacing between buttons
                    padding: '15px',
                    width: '100%', // Adjust width as needed
                    background: 'white',
                    borderRadius: '8px',
                    alignContent: "center",
                    alignItems: "center"
                }}>
                    <Button2 style={{
                        minWidth: "350px",
                        minHeight: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",

                    }}
                        onClick={() => {setShowEdit(true); setShowEditRule(false)}}>View/edit rule</Button2>

                    {(role === "admin" || role === "TechSupport") && <Button2 style={{
                        minWidth: "350px",
                        minHeight: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#ff5c5c"
                    }}
                        onClick={() => setShowConfirmation(true)}>Delete rule</Button2>}

                    <Button2 style={{
                        minWidth: "350px",
                        minHeight: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                        onClick={() => setShowEditRule(false)}>Cancel</Button2>
                </div>


            </Dialog>
            
            <RuleCard
                header={`Rule`}
                subHeader={
                    `${ruleName}`
                }
                onClick={() => (role === "admin" || role === "TechSupport") && ruleOwner == DeviceUUID ? setShowEditRule(true) : null}
                trigger={triggerItems}
                actions={actionItems}
                meta={[]}
                rightContent={
                <>
                    <Pill_Widget onClick={() => ruleOwner == DeviceUUID ? setShowEditRule(true) : null} boolean={ruleEnabled} PillColor_IfTrue={"var(--Active-color)"} PillColor_IfFalse={"var(--Inactive-color)"} text_IfTrue={"Active"} text_IfFalse={"Inactive"} className={classes.PillHeight} />
                </>
                }
                footer={
                                    createdBy && created
                                      ? `Created by ${createdBy} on ${format(
                                          new Date(created),
                                          "MMM do, yyyy - HH:mm"
                                        )}`
                                      : null
                                  }     
            />
        </>
    )
}

export default AdvRuleLayout;




